// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"148a7b26","764":"14383e81","888":"abf19da9"}[chunkId] + ".chunk.js";
};